var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1818 14.0909C27.1818 24.2727 14.0909 33 14.0909 33C14.0909 33 1 24.2727 1 14.0909C1 6.861 6.861 1 14.0909 1C21.3208 1 27.1818 6.861 27.1818 14.0909Z",
    fill: "#505363",
    stroke: "#505363",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0907 18.4543C16.5007 18.4543 18.4543 16.5007 18.4543 14.0907C18.4543 11.6807 16.5007 9.72705 14.0907 9.72705C11.6807 9.72705 9.72705 11.6807 9.72705 14.0907C9.72705 16.5007 11.6807 18.4543 14.0907 18.4543Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRoute);
export default __webpack_public_path__ + "static/media/marker-route.e6bbe0cbbfb3319028f3f4ebf109b0ae.svg";
export { ForwardRef as ReactComponent };